<template>
  <div class="register-player">
    <label :for="`input-${label}-id`">{{ label }}</label>
    <input
      class="input"
      :id="`input-${label}-id`"
      type="text"
      v-model.trim="playerName"
      :placeholder="placeholder"
      @keydown.enter="validateInput"
      autocomplete="off"
    />
    <!--<input
            disabled
            class="input"
            id="input-phone-id"
            type="text"
            v-if="playerphone!=='Phone Number Not Set'"
            v-model.trim="playerPhone"
            placeholder="0722000000"
            @keydown.enter="validateInput"
            autocomplete="off"
    />
    -->
    <n-button
      @click.native="validateInput"
      :title="buttonTitle"
      :is-loading="isLoading"
    />
    <p class="error-message" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import Button from "@/components/general/Button";
export default {
  components: {
    "n-button": Button
  },
  data() {
    return {
      disabled:true,
      label: "What do we call you?",
      placeholder: "Nickname",
      playerName: null,
      playerPhone:null,
      buttonTitle: "Start Game",
      error: false,
      phoneno:/^0(7(?:(?:[129][0-9])|(?:0[0-8])|(4[0-1]))[0-9]{6})$/
    };
  },
  mounted()
  {
    this.playerPhone =this.playerphone;
    this.playerName = this.playername;
    if (this.playername === '')
    {
      this.disabled=false;
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    playername()
    {
      return this.$store.state.scores.playerOne.name;
    },
    playerphone()
    {
      return this.$store.state.scores.playerOne.phone;
    }
  },
  watch: {
    playerName() {
      if (this.error) {
        this.error = false;
        this.$emit("error", false);
      }
    }
  },
  methods: {
    validateInput() {
      const name = this.playerName;
      const phone = this.playerPhone;
      //let phoneno = /^0(7(?:(?:[129][0-9])|(?:0[0-8])|(4[0-1]))[0-9]{6})$/;
      if (name !=='' && !this.isLoading) {
          this.registerNewPlayer();
        }else
      {
        this.$store.commit('flushMessages', 'Please provide a nickname to proceed!');
      }

    },
    registerNewPlayer() {
      let vm = this;
      let pl = this.$store.dispatch("registerNewPlayer", {'name':this.playerName,'phone':this.playerPhone});
      this.$store.commit('pauseGame');
      this.$store.commit('playerClickedCard',false);
      this.$store.commit('setResults',false);
    }
  }
};
</script>
<style>
  ::placeholder {
    color: rgba(0, 0, 0, 0.38)!important;
    opacity: 1!important; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(0, 0, 0, 0.38)!important;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba(0, 0, 0, 0.38)!important;
  }
</style>
<style lang="sass" scoped>

.register-player
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  text-align: center

.input
  margin: 1rem
  color: inherit
  font: inherit
  outline: 0
  background: 0
  border: 1px solid $color-gray
  -webkit-appearance:none
  border-radius: $border-radius
  padding: 0.5rem 1rem
  text-align: center
  font-size: $font-size-large
  font-weight: 600
  max-width: 18rem
  width: 100%

.input::placeholder
  color: $color-gray--darker

.error-message
  margin-top: 0.5rem
  max-width: 250px
</style>
